import { useState } from "react";
import { useResetInputs } from "src/Contexts";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { api } from "src/shared/setup/API/api";

interface IUseFormSubmit {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFeaturesFormulario = (
  { setOpenModal }: IUseFormSubmit
) => {
  const { valuesInputsComissaoProdutor } = useContextComissoes();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const {
    valueAutoCompProdutorActive,
    valueAutoCompAdministradora,
    valueAutoCompModalidade,
    valueAutoCompOperadora,
  } = UseAutoCompletedAll();

  const { setAttTable, id } = useConfigPageContext();
  const { resetInputs } = useResetInputs();

  const objComissao = {
    name: valuesInputsComissaoProdutor.name,
    date_vigencia: valuesInputsComissaoProdutor.date_vigencia,

    code_operadora: Number(valueAutoCompOperadora.id),
    code_modalidade: Number(valueAutoCompModalidade.id),
    vitalicio: valuesInputsComissaoProdutor.vitalicio === "NONE" ? null : Number(valuesInputsComissaoProdutor.vitalicio),

    code_administradora: valueAutoCompAdministradora.id
      ? Number(valueAutoCompAdministradora.id)
      : null,

    funcao_produtor: valuesInputsComissaoProdutor.funcao_produtor,

    tipo_produtor: valuesInputsComissaoProdutor.tipo_produtor,

    is_special: valuesInputsComissaoProdutor.is_special === "true",

    code_produtor: valuesInputsComissaoProdutor.is_special
      ? String(valueAutoCompProdutorActive.id)
      : "",

    numero_parcela: {
      parc_1: valuesInputsComissaoProdutor.parc_1,
      parc_2: valuesInputsComissaoProdutor.parc_2,
      parc_3: valuesInputsComissaoProdutor.parc_3,
      parc_4: valuesInputsComissaoProdutor.parc_4,
      parc_5: valuesInputsComissaoProdutor.parc_5,
      parc_6: valuesInputsComissaoProdutor.parc_6,
      parc_7: valuesInputsComissaoProdutor.parc_7,
      parc_8: valuesInputsComissaoProdutor.parc_8,
      parc_9: valuesInputsComissaoProdutor.parc_9,
      parc_10: valuesInputsComissaoProdutor.parc_10,
      parc_11: valuesInputsComissaoProdutor.parc_11,
      parc_12: valuesInputsComissaoProdutor.parc_12,
    },
  };

  const handleCreate = async (isNotClose?: boolean) => {
    if (!objComissao.code_operadora) return handleGetAlert({ message: `Escolha uma operadora !` });
    if (!objComissao.code_modalidade) return handleGetAlert({ message: `Escolha uma modalidade !` });
    if (!objComissao.date_vigencia) return handleGetAlert({ message: `Escolha uma data de vigência !` });

    setLoading(true);

    return api
      .post("/comissoes/produtor/create", { ...objComissao })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModal(isNotClose ?? false);
        resetInputs();
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEdit = () => {
    if (!objComissao.code_operadora) return handleGetAlert({ message: `Escolha uma operadora !` });
    if (!objComissao.code_modalidade) return handleGetAlert({ message: `Escolha uma modalidade !` });
    if (!objComissao.date_vigencia) return handleGetAlert({ message: `Escolha uma data de vigência !` });

    setLoading(true);

    return api
      .put(`/comissoes/produtor/${id}`, { ...objComissao })
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = (isNotClose?: boolean) => {
    if (id) {
      handleEdit();
    } else {
      handleCreate(isNotClose);
    }
  };

  return { handleSubmit, loading };
};
